let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jQZ1Q")).then(() => parcelRequire('aCd44'));